var _path, _path2, _path3, _path4, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTransactionEmergencyBucket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3105 24.5111L21.2866 19.9556C21.5023 18.9491 20.735 18 19.7057 18C18.6763 18 17.9091 18.9491 18.1247 19.9556L19.1009 24.5111C19.162 24.7963 19.414 25 19.7057 25C19.9973 25 20.2493 24.7963 20.3105 24.5111Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7057 28C19.4303 28 19.1948 27.9022 18.9992 27.7065C18.8035 27.5109 18.7057 27.2754 18.7057 27C18.7057 26.7246 18.8035 26.4891 18.9992 26.2935C19.1948 26.0978 19.4303 26 19.7057 26C19.9811 26 20.2166 26.0978 20.4122 26.2935C20.6079 26.4891 20.7057 26.7246 20.7057 27C20.7057 27.2754 20.6079 27.5109 20.4122 27.7065C20.2166 27.9022 19.9811 28 19.7057 28Z",
    fill: "#0E5CF4",
    stroke: "#0E5CF4",
    strokeWidth: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7057 15H28.7057L27.5054 30.87C27.4572 31.5074 26.926 32 26.2867 32H13.1247C12.4854 32 11.9541 31.5074 11.9059 30.87L10.7057 15Z",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7057 12H28.7057L28.1924 10.0038C27.7378 8.23588 26.1439 7 24.3184 7H15.093C13.2675 7 11.6736 8.23588 11.219 10.0038L10.7057 12Z",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.7057,
    y: 6,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#0E5CF4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.70569,
    y: 12,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "white",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionEmergencyBucket);
export default __webpack_public_path__ + "static/media/ic-transaction-emergency-bucket.2c78ec62c47d99776e8fd8e82f038c0b.svg";
export { ForwardRef as ReactComponent };